import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IParameter } from "../types/Types";

/**
 * @author mb
 */
export const ParameterAPI = createApi({
    reducerPath: "parameterAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "parameter",
            credentials: 'include'
        }),
    tagTypes: ['parameterAPI'], // for caching
    endpoints: (builder) => ({
        getAllParameter: builder.mutation<IParameter[], void>(
            {
                query: () => ({
                    url: '',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getParameter: builder.mutation<IParameter, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        deleteParameter: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'delete',
                    credentials: 'include',
                })
            }
        ),
        createOrUpdateParameter: builder.mutation<void, IParameter>(
            {
                query: (dto) => ({
                    url: `createOrUpdate`,
                    method: 'put',
                    credentials: 'include',
                    body: dto
                })
            }
        ),


    })
});

export const {

    useGetAllParameterMutation,
    useGetParameterMutation,
    useCreateOrUpdateParameterMutation,
    useDeleteParameterMutation,

} = ParameterAPI;
